import { TextField } from '@mui/material'
import { Controller } from 'react-hook-form'
import { SelectInputForm } from '../../../components/common/form'

const AmountUnits = ({ amount, unit, control, optionsUnits }) => {
  return (
    <>
      <Controller
        name={amount}
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            type="number"
            inputProps={{ min: 1 }}
            size="small"
            sx={{ width: 150 }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />

      <SelectInputForm name={unit} control={control} options={optionsUnits} required sx={{ width: 150 }} />
    </>
  )
}

export default AmountUnits
